<ng-container *transloco="let convert;">
  <app-modal [modalId]="auction-selection-modal">
    <header class="modal__header">
      <h1 class="modal__title"
        [attr.id]="modalId + '-title'"
        tabindex="-1">
        {{convert('sellModule.posting.repostModal.auctionSelection.textSelectAuction')}}
      </h1>
    </header>
    <div class="modal__content">
      <p>
        {{convert('sellModule.posting.repostModal.auctionSelection.selectAuctionInfo')}}
      </p>
      <form class="control-wrapper">
        @for (auction of auctionLaneData; track auction; let i = $index) {
          <div class="custom-control custom-radio"
            >
            <input class="custom-control-input"
              type="radio"
              id="auction-{{ i }}"
              name="auction-radios"
              [checked]="isSelectedAuction(auction)"
              (change)="updateSelection(auction)">
            <label class="custom-control-label" for="auction-{{ i }}">
              {{convert('sellModule.posting.repostModal.auctionSelection.' + auction.code)}}
            </label><br/>
            <p class ="label-option-description" for="'auction-{{ i }}">
              {{ auction.name }} <br>
              {{ auction.description }}
            </p>
          </div>
        }
      </form>
      <div class="modal__actions">
        <div class="modal__action">
          <button
            [attr.aria-label]="convert('sellModule.posting.repostModal.auctionSelection.saveButton')"
            class="btn btn-primary mt-4"
            data-track-name="Save Auction Selection"
            (click)="saveAndClose()"
            >
            {{convert('sellModule.posting.repostModal.auctionSelection.saveButton')}}
          </button>
        </div>
        <div class="modal-close-container">
          <button
            class="modal__close"
            aria-label="Close modal"
            (click)="close()"
            data-track-elem="icon"
            data-track-name="Close"
            data-track-trigger="close"
            id="do_close_x_button"
            >
            <i class="allycon-glyph-close text-primary" aria-hidden="true"></i>
          </button>
        </div>
      </div>
    </div>
  </app-modal>
</ng-container>
